import { render, staticRenderFns } from "./onboard.vue?vue&type=template&id=65ce7d49&scoped=true&"
import script from "./onboard.vue?vue&type=script&lang=js&"
export * from "./onboard.vue?vue&type=script&lang=js&"
import style0 from "./onboard.vue?vue&type=style&index=0&id=65ce7d49&lang=scss&scoped=true&"
import style1 from "./onboard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ce7d49",
  null
  
)

export default component.exports